import type { IBrandOwner } from 'types/brands.types';


import './style.scss';

interface OwnerCardProps {
    owner: IBrandOwner
}

export default function OwnerCard({ owner: { full_name } }: OwnerCardProps) {
  return (
    <div className="brand-owner-card">
      <span className="brand-owner-card-name">{full_name}</span>
    </div>
  );
}
